import React, { useState, useEffect, useContext } from 'react';
import { MsalContext } from '../Contexts/MsalContext';
import Paper from '@mui/material/Paper';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { formatDate } from '../Utilities/UtilityMethods';

const styles = {
    root: {
        color: 'black',
    },
    paper: {
        backgroundColor: 'var(--colour-lilac)',
        padding: '8px',
    },
    table: {
        backgroundColor: '#fff',
    },
    bold: {
        fontWeight: 'bold',
    },
    error: {
        color: 'red',
    }
}

export default function TagList() {
    const { msalFetch } = useContext(MsalContext);
    const [tagList, setTagList] = useState<any>(null);
    const [tagListLoaded, setTagListLoaded] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [newTag, setNewTag] = useState('');
    const [username, setUsername] = useState('');
    const [errorMessage, setErrorMessage] = useState<any>(undefined);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        msalFetch('api/User/getUserName')
            .then(response => response.text())
            .then(data => {
                setUsername(data);
            });

        msalFetch('api/Management/GetTags')
            .then(Response => Response.json())
            .then(Data => {
                setTagList(Data);
                setTagListLoaded(true);
            });

        msalFetch('api/User/IsAdmin')
            .then(resp => resp.json())
            .then(dat => {
                setIsAdmin(dat);
            });
    }

    const addTag = () => {

        msalFetch('api/Management/AddTag?tag=' + newTag)
            .then(response =>
                addTagCallBack(response)
            )
            .then(response =>
                fetchData()
            )

    }

    const addTagCallBack = (Response) => {
        if (Response.ok === true) {
            const newTagName: HTMLInputElement = document.getElementById('newTagName') as HTMLInputElement;
            newTagName.value = '';
            setErrorMessage(undefined);
        } else {
            setErrorMessage(<Typography id="errorMessage" sx={styles.error}>Error: tag already exists </Typography>);
        }
    }

    const newTagTextChanged = (e) => setNewTag(e.currentTarget.value);

    return (
        (tagListLoaded && isAdmin) ?
            <Paper sx={styles.paper}>
                <Table sx={styles.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Tag</TableCell>
                            <TableCell>Author</TableCell>
                            <TableCell>Created</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <TextField label="Add new tag" type="text" id="newTagName" key="newTagName" onChange={newTagTextChanged} value={newTag} />
                            </TableCell>
                            <TableCell>
                                <Typography variant="subtitle1">{username}</Typography>
                            </TableCell>
                            <TableCell>
                                <Button color="secondary" variant="contained" onClick={addTag}>Add Tag</Button>
                                {errorMessage}
                            </TableCell>
                        </TableRow>
                        {tagListLoaded && tagList.map(row => {
                            return (
                                <TableRow key={row.tagID}>
                                    <TableCell>{row.tag}</TableCell>
                                    <TableCell>{row.author}</TableCell>
                                    <TableCell>{formatDate(row.created)}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Paper>
            :
            <React.Fragment />
    );
}